"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

var classnames_1 = __importDefault(require("classnames"));

require("./styles.css");

var Link = function (_a) {
  var _b;

  var to = _a.to,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      _d = _a.iconClassName,
      iconClassName = _d === void 0 ? '' : _d,
      children = _a.children,
      disabled = _a.disabled,
      withIcon = _a.withIcon,
      onClick = _a.onClick;
  var bem = (0, hook_use_bem_classes_1.default)('rwc-link');
  var classes = (0, classnames_1.default)(bem(), className, {
    disabled: disabled
  });
  var iconClasses = (0, classnames_1.default)((_b = {}, _b[iconClassName] = iconClassName, _b));
  return (0, jsx_runtime_1.jsxs)("a", __assign({
    href: to,
    className: classes,
    onClick: onClick
  }, {
    children: [children, withIcon && (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
      type: "fas-external-link",
      className: iconClasses,
      style: {
        width: 12,
        height: 12
      }
    })]
  }));
};

exports.default = Link;